import { createSlice } from '@reduxjs/toolkit';

const initialState = [];

const campaignsSlice = createSlice({
    name: 'campaigns',
    initialState,
    reducers: {
        setCampaigns: (state, action) => {
            return action.payload;
        },
        removeCampaigns: () => {
            return initialState;
        },
    },
});

export const { setCampaigns, removeCampaigns } = campaignsSlice.actions;
export default campaignsSlice.reducer;